import { formatDateToApi } from '../../../../../../../../utils/dates';
import OrderConditionCustomFieldType from '../../../../../../conditions/enums/orderConditionCustomFieldType.enum';
import { OrderConditionSubmitData } from '../../../../../../conditions/orderCondition.types';
import { BuildOrderConditionUpdateDtoParams } from './orderConditionDefinitionsModal.types';

export const serializeCustomFieldValue = (
  type: OrderConditionCustomFieldType,
  value: unknown,
): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (type === OrderConditionCustomFieldType.DATE && value instanceof Date) {
    return formatDateToApi(value);
  }

  return String(value);
};

export const buildOrderConditionUpdateDto = ({
  conditionId,
  values,
  selectedOrderOperation,
  selectedOrderBatchItem,
  customFields,
  customFieldValues,
}: BuildOrderConditionUpdateDtoParams) =>
  ({
    id: conditionId,
    orderCollectionId: values.orderCollectionId,
    saleTypeId: values.saleTypeId,
    branchId: values.branchId,
    freightType: values.freightType,
    shippingCompanyId: values.shippingCompanyId,
    brandFreightTypeId: values.brandFreightTypeId,
    orderOperationCode: selectedOrderOperation,
    orderChargeTypeCode: values.orderChargeTypeCode ? Number(values.orderChargeTypeCode) : null,
    orderBatchItemCode: selectedOrderBatchItem,
    orderClassifications:
      values.orderClassificationTypeCode && values.orderClassificationCode
        ? [
            {
              code: values.orderClassificationCode,
              typeCode: values.orderClassificationTypeCode,
            },
          ]
        : [],
    emitInvoice: values.emitInvoice,
    customFields: customFields.map((config) => ({
      configId: config.id,
      value: serializeCustomFieldValue(config.type, customFieldValues[config.id]),
    })),
  }) as unknown as Partial<OrderConditionSubmitData>;
